import { Spinner, useIntl } from "@metsooutotec/modes-react-components"
import { ProvisionEvent } from "features/provisioning/provisions/models/provision-models"
import React, { Suspense } from "react"
import { Await, defer, Outlet, useLoaderData } from "react-router-dom"
import provisionEventStore from "features/provisioning/provisions/stores/provision-event-store"

export async function provisionEventsRouteDataLoader(): Promise<{ data: Record<string, unknown> }> {
    const { loadAllProvisionEvents } = provisionEventStore

    return defer({
        provisionEvents: loadAllProvisionEvents(),
    })
}

const ProvisionEventsLoader: React.FC = () => {
    const { formatMessage } = useIntl()
    const data = useLoaderData() as { provisionEvents: Promise<Record<string, unknown>> }

    return (
        <Suspense fallback={<Spinner text={formatMessage("provisionEvents.loading")} style={{ zIndex: 8 }} />}>
            <Await resolve={data.provisionEvents} children={(provisionEvents: ProvisionEvent[]) => <Outlet context={{ provisionEvents }} />} />
        </Suspense>
    )
}
export default ProvisionEventsLoader
